import { styled } from '@mui/system';
import { Box, Typography, Stack } from '@mui/material';
import { qnTexts } from 'shell/OnlineBookingTheme/themes/_palette';


const DefaultQuestionRoot = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.neutrals.whiteSpace,

}));
const TitleBox = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(0.5),
    ".MuiTypography-root": {
        color: qnTexts.darkGreyMediumEmphasis,
        fontSize: '16px',
        fontWeight: 500,
    }
}));
const SubTitleBox = styled(Box)(({ theme }) => ({
    ".MuiTypography-root": {
        color: theme.vars.palette.texts.action,
        fontSize: '14px',
    }
}));

const DefaultQuestion = ({ type, value, ...props }) => {
    const { title, additionalText } = value;
    return (
        <DefaultQuestionRoot {...props}>
            <Stack direction='column' justifyContent='space-between' alignItems='start'>
                <TitleBox>
                    <Typography variant='h1'> {title} </Typography>
                </TitleBox>
                <SubTitleBox>
                    <Typography > {additionalText} </Typography>
                </SubTitleBox>

            </Stack>
        </DefaultQuestionRoot >
    );
}

export default DefaultQuestion;